
  import { defineComponent } from "vue";

  export default defineComponent({
    name: 'VueBox',
    data () {
      return {
        estilos: {
          background: '#FAF0CA',
        }
      }
    }
  });
